import { render, staticRenderFns } from "./MaterialSelectModal.html?vue&type=template&id=533523de&scoped=true&external"
import script from "./MaterialSelectModal.ts?vue&type=script&lang=ts&external"
export * from "./MaterialSelectModal.ts?vue&type=script&lang=ts&external"
import style0 from "./MaterialSelectModal.css?vue&type=style&index=0&id=533523de&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533523de",
  null
  
)

export default component.exports